import { differenceInYears } from 'date-fns';

type AgeCategory = 'adults' | 'children' | 'pensioners' | 'students';

const CHILDREN_MAX = 7;
const STUDENT_MAX = 18;
const ADULT_MAX = 70;
const PENSIONER_MAX = 120;

const AGES = {
  adults: [ADULT_MAX, STUDENT_MAX],
  children: [CHILDREN_MAX, 0],
  pensioners: [PENSIONER_MAX, ADULT_MAX],
  students: [STUDENT_MAX, CHILDREN_MAX],
} as const;

/**
 * Returns travelers age category based on his birthDate (age)
 * - 0-6 - children
 * - 7-18 - student
 * - 18-69 - adult
 * - 70+ - senior
 */
function getAgeCategory(birthDate: string | Date, diffDate: Date): AgeCategory;
function getAgeCategory(
  birthDate?: string | Date,
  diffDate?: Date,
): AgeCategory | undefined;
function getAgeCategory(
  birthDate: string | Date | undefined,
  diffDate = new Date(),
): AgeCategory | undefined {
  if (!birthDate) {
    return undefined;
  }

  const years = differenceInYears(diffDate, new Date(birthDate));

  return years < CHILDREN_MAX
    ? 'children'
    : years < STUDENT_MAX
      ? 'students'
      : years < ADULT_MAX
        ? 'adults'
        : 'pensioners';
}

export type { AgeCategory };
export {
  ADULT_MAX,
  AGES,
  CHILDREN_MAX,
  getAgeCategory,
  PENSIONER_MAX,
  STUDENT_MAX,
};
